
import { IconButton, Stack } from '@mui/material';
import { Cancel, CheckCircle } from '@mui/icons-material';
import Model from '../models/model';

const CiResultButton = ({ inputProps }) => {
	const { formik, activeRecord } = inputProps;
	return (
		<Stack direction="row" spacing={2} sx={{
			'& .MuiIconButton-root': {
				'&.IsSelected': {
					backgroundColor: (theme) => theme.palette.divider,
				}
			}
		}}>
			<IconButton color="success" className={parseInt(activeRecord.CIResult) === 1 ? 'IsSelected' : ''} onClick={() => {
				formik.setFieldValue('CIResult', 1)
				activeRecord.CIResult = 1
			}}>
				<CheckCircle fontSize='inherit' />
			</IconButton>
			<IconButton color="error" className={parseInt(activeRecord.CIResult) === 2 ? 'IsSelected' : ''} onClick={() => {
				formik.setFieldValue('CIResult', 2)
				activeRecord.CIResult = 2
			}}>
				<Cancel fontSize='inherit' />
			</IconButton>
		</Stack>
	)
}
const model = new Model({
	name: 'IncubatorCycle',
	showGridRefreshBtn: true,
	onFormLoad: ({ formik, activeRecord }) => {
		if(!activeRecord.id){
			formik.setFieldValue('CIResult', undefined);
		}
	},
	customizeSaveData: (toSave, { activeRecord }) => {
		const { combos } = activeRecord;
		const { BILotNumber, CILotNumber } = combos;
		const ciLotNumber = CILotNumber?.find((data) => (data.DisplayValue === toSave.CILotNumberId));
		const biLotNumber = BILotNumber?.find((data) => data.DisplayValue === toSave.BILotNumberId);
		toSave.CILotNumberId = ciLotNumber ? ciLotNumber?.id : toSave.CILotNumberId;
		toSave.BILotNumberId = biLotNumber ? biLotNumber?.id : toSave.BILotNumberId;
	},
	columns: [
		{ header: 'LotNumber', field: 'CILotNumberId', lookup: 'CILotNumber' ,},
		{ header: 'CIResult', field: 'CIResult', customizeInput: CiResultButton, required: true, type: 'number' },
	]
});
export const DashBordCIForm = model;
export default model.createFormBase();
